import createVueApp from '@phoenix/createVueApp';
import ScrollableModalWw25 from '@maison/components/scrollable-modal-ww25/ScrollableModalWw25.vue';

document.querySelectorAll('.phoenix-modal-scrollable-modal').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('ScrollableModalWw25', ScrollableModalWw25);
  app.mount(el);
});
